import { useI18n } from 'vue-i18n'
import { useOptionsFormatter } from '@/composables/optionsFormatter'
import CellStatus from '@/apps/MainApp/views/Dashboard/TableCells/CellStatus.vue'

export const registerStatusColumn = (dashboard) => {
  const { t, te } = useI18n()
  const { requestStatusOptions } = useOptionsFormatter()

  dashboard.registerCustomColumn({
    name: 'status',
    label: 'monolith.shared.status_col',
    component: CellStatus,
    options: {
      format: (status, row) => ({
        label: te(`status.${status}`) ? t(`status.${status}`) : status,
        value: status,
        badges: row?.badges,
      }),
      selectOptions: requestStatusOptions,
      isMultiSelect: true,
    },
  })
}
